export const signIn = () => {
  return {
    title: 'Iniciar Sesión',
    subtitle_1: 'Por favor inicie sesión con su correo empresarial',
    sign_in_google: 'Inicie sesión con Google',
    sign_in_microsoft: 'Inicie sesión con Microsoft',
    email_address: 'Ingrese usuario o correo',
    password: 'Ingrese contraseña',
    remember_me: 'Recordarme',
    forgot_password: 'Olvidó su contraseña?',
    request_access: 'Solicitar Accesso',
    sign_in: 'Iniciar Sessión',
    management_portal: 'Management Portal',
    main_message: 'Administre su aplicación móvil FieldTech Connect y formularios de campo personalizados.',
    contact_us: 'Contáctenos',
    messages: {
      wrong_user_password: 'Las credenciales ingresadas no son válidas. Por favor intente nuevamente.',
      terms_and_conditions: 'Al utilizar la plataforma MyWork, usted acepta los ',
      terms_and_conditions_link: 'términos y condiciones.',
      privacy_policy: 'Política de Privacidad',
      my_work_all_rights_reserved: 'MyWork, LLC Todos los Derechos Reservados'
    },
    masquerade: {
      title: 'Máscara',
      mask_as: 'Enmascarando como',
      subtitle: 'Seleccione un cliente para enmascarar su usuario y que se le permita ayudar en la solucion de problemas específicos.',
      skip: 'Ignorar',
      go: 'Entrar',
      start: 'Iniciar',
      search_client: 'Buscar el Nombre del Cliente',
      search_client_mobile: 'Buscar Cliente',
      frequently: 'Frecuentemente usados',
      no_frequently: 'No existen clientes usados últimamente',
      no_client: 'Cliente No Seleccionado',
      switch: 'Cambiar Cliente',
      back: 'Regresar'
    },
    logout: {
      title: 'Su Sesión ha Expirado',
      message:
        'Lo sentimos, algo ha pasado con su sesión. Inicie sesión de nuevo para asegurar que su trabajo este actualizado.'
    },
    invalid_user: {
      title: 'Credentiales incorrectas',
      message: 'Las credenciales ingresadas no son válidas. Por favor, intente nuevamente.'
    }
  }
}
